import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {UrlService} from '../../../common/services/url/url.service';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {UrlModel} from '../../../common/services/url/url.model';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '@Common/widgets/general/data-table';
import {FormulaireService} from '../../../common/services/formulaire/formulaire.service';
import {FormModel, FormState} from '../../../common/components/form/models';
import {DomSanitizer} from '@angular/platform-browser';
import {SafeHtmlPipe} from '@Common/widgets/pipes';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {Individu, IndividuService, PubSubService} from '@Common/core/services';
import {SubSink} from '@Common/core/utils/subsink';
import {roles} from '../../../common/enum/roles';
import {MatDialog} from '@angular/material/dialog';
import {ModalUrlEditComponent} from '../url-edit/url-edit-modale/modal-url-edit.component';
import {
  ModaleRenduFormulaireComponent
} from '../../formulaires-liste/rendu-formulaire/modale-rendu-formulaire-container/modale-rendu-formulaire.component';
import {HelperService} from '../../../common/services/helper.service';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {concatMap, finalize} from 'rxjs/operators';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {Clipboard} from '@angular/cdk/clipboard';
import {FormStateOptionsModel} from '../../../common/services/states/form-state-options.model';
import {StatesFormService} from '../../../common/services/states/states-form.service';

@Component({
  selector: 'app-url-list',
  templateUrl: './url-list.component.html',
  styleUrls: ['./url-list.component.scss']
})
export class UrlListComponent implements OnInit, OnChanges {
  dsUrls: MatDataSourceGeneric<UrlModel> = new MatDataSourceGeneric<UrlModel>();
  private _puslished_offline = `${FormState.published.toString()}, ${FormState.offline.toString()}`;
  extraParams: Map<string, string> = new Map<string, string>([
    ['form_state_in', this._puslished_offline]]);
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  columns: ColumnDataTable[] = [
    {
      columnDef: 'link',
      header: 'Lien demandeur',
      display: (row: UrlModel) => this._getLink(row),
      color: (row: UrlModel) => 'blue',
      flex: 25,
      sort: false
    },
    {
      columnDef: 'form__nom',
      header: 'Pointe vers le formulaire',
      display: (row: UrlModel) => row.form_obj?.nom,
      tooltip: (row: UrlModel) => row.form_obj?.nom,
      color: (row: UrlModel) => 'green',
      truncate: true,
      sort: true
    },
    {
      columnDef: 'form__state',
      header: 'Etat formulaire',
      display: (row: UrlModel) => this._stateForm(row.form_obj),
      tooltip: (row: UrlModel) => this._stateTooltipForm(row.form_obj),
      sort: false
    },
  ];
  actions: ActionDataTable[] = [
    {
      label: 'content_copy', tooltip: 'Copier le lien', icon: 'content_copy',
      hidden: (row: UrlModel) => !this._isPublished(row),
      click: (row: UrlModel) => this._copy_url(row),
    },
    {
      label: 'visualize', tooltip: 'Visualiser le formulaire', icon: 'remove_red_eye',
      click: (row: UrlModel) => this._visualize(row),
      iconcolor: 'accent',
    },
    {
      label: 'edition', tooltip: 'Faire pointer ce lien vers un autre formulaire', icon: 'swap_horiz',
      hidden: (row: UrlModel) => ! this._hasLink(row),
      click: (row: UrlModel) => this._openModaleUrlEdit(row),
    },
    {
      label: 'delete', tooltip: 'Supprimer le lien', icon: 'delete',
      click: (row: UrlModel) => this._delete_slug(row),
      hidden: (row: UrlModel) => ! this._hasLink(row),
      iconcolor: 'warn',
    },
  ];

  publishedOnly = true;
  screenHeight: number;
  screenWidth: number;
  subSink = new SubSink();
  @Input() adminView = false;
  connecte: Individu;

  constructor(private sanitized: DomSanitizer,
              private dialog: MatDialog,
              private individuService: IndividuService,
              private toastySvc: SnackBarToastyService,
              private pubSubSvc: PubSubService,
              private helperSvc: HelperService,
              private statsFormSvc: StatesFormService,
              private urlSvc: UrlService,
              private formSvc: FormulaireService,
              private clipboard: Clipboard) {
    this.dsUrls.daoService = this.urlSvc;
  }

  ngOnInit(): void {
    this.subSink.sink = this.individuService.individu$.subscribe((individu: Individu) => {
      this.connecte = individu;
      const isAdmin = this.individuService.hasRole(individu, roles.admin);
      if (!isAdmin || !this.adminView) {
        this.extraParams.set('by_gestionnaire', individu.uid);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const cur = changes.adminView.currentValue
    const old = changes.adminView.previousValue
    if (cur != old && !changes.adminView.firstChange) {
      if (cur) {
        this.extraParams.delete('by_gestionnaire');
      }
      else {
        this.extraParams.set('by_gestionnaire', this.connecte.uid);
      }
      this.dataTable.reload();
    }
  }

  _stateForm(form: FormModel) {
    if (form) {
      const sp: SafeHtmlPipe = new SafeHtmlPipe(this.sanitized);
      const state: FormStateOptionsModel = this.statsFormSvc.getStateModel(form.state);
      const display = `<span style="border-radius: 10px; background-color: ${state.color}; padding: 5px; color: white;">&nbsp;&nbsp;&nbsp;</span>`;
      return sp.transform(display);
    }
    return '';
  }
  _stateTooltipForm(form: FormModel) {
    if (form) {
      const state: FormStateOptionsModel = this.statsFormSvc.getStateModel(form.state);
      return state.label;
    }
    return '';
  }
  onStateFiltered(event: MatCheckboxChange) {
    if (event.checked) {
      this.publishedOnly = false;
      this.extraParams.delete('form_state_in');
    } else {
      this.publishedOnly = true;
      this.extraParams.set('form_state_in', this._puslished_offline);
    }
    this.dataTable.reload();
  }
  private _isPublished(url: UrlModel) {
    return url?.form_obj?.state === FormState.published;
  }
  private _hasLink(url: UrlModel) {
    return [FormState.published, FormState.offline].includes(url?.form_obj?.state);
  }
  private _getLink(url: UrlModel) {
    if (this._hasLink(url)) {
      return this.formSvc.formUrlDemandeurBySlug(url.slug);
    }
    const sp: SafeHtmlPipe = new SafeHtmlPipe(this.sanitized);
    return sp.transform(`<span style="color: red; font-style: italic;">non publié</span>`);
  }

  /**
   * Changement du formulaire sur l'URL
   * - on fait pointer l'url sur le nouveau formulaire
   * - on archive l'ancien formulaire
   * - on supprime toutes les urls suceptibles de pointer sur cet ancien formulaire
   * @param {FormModel} currentForm : ancien formulaire à dépointer sur l'url : il se sera archivé
   * @param {FormModel} newForm : pointage de l'url vers ce formulaire
   * @param {UrlModel} urlCurrent : l'url à modifier pour le nouveau formulaire
   * @private
   */
  private _switchForms(currentForm: FormModel, newForm: FormModel, urlCurrent: UrlModel) {
    if (currentForm && newForm) {
      const _urlCurrent = <UrlModel>{
        id: urlCurrent.id,
        form: newForm.id
      };
      currentForm.state = FormState.archived;
      this.subSink.sink = this.formSvc
        .patch(currentForm, 'uuid')
        .pipe(
          concatMap(_ => this.urlSvc.patch(_urlCurrent)),
          concatMap(_ => this.urlSvc.deleteUrlByForm(currentForm.id)))
        .subscribe(_url => {
          this.toastySvc.toasty('Lien formulaire', 'le changement de formulaire a bien été pris en compte', typeToast.success);
          this.dataTable.reload();
        });
    }
  }
  private _openModaleUrlEdit(urlCurrent: UrlModel) {
    const modal = this.dialog.open(ModalUrlEditComponent, {data: urlCurrent});
    const top = 50;
    modal.disableClose = true;
    modal.updatePosition({top: `${top}px`});
    modal.afterClosed()
      .subscribe(([_currentForm, _newForm]: [FormModel, FormModel]) => this._switchForms(_currentForm, _newForm, urlCurrent));
  }
  /**
   * Ouverture modale de prévisualisation - sans cadre gestion - s'adapte à l'écran
   * @private
   */
  private _visualize(url: UrlModel) {
    [this.screenHeight, this.screenWidth] = this.helperSvc.getScreenSize();
    const top = 50;
    const width = this.screenWidth - 50;
    const height = this.screenHeight - (2 * top);
    const dialogRef = this.dialog.open(ModaleRenduFormulaireComponent, {
      width: '680px',
      data: url.form_obj,
    });
    dialogRef.updatePosition({top: `${top}px`});
    dialogRef.updateSize(`${width}px`, `${height}px`);
  }
  private _delete_slug(url: UrlModel) {
    const data = new DialogData();
    data.title = `Suppression du lien vers "${url.form_obj.nom}"`;
    data.iconType = 'warning';
    data.message = `Lien : ${this. _getLink(url)}<br/>
                    <p>Le <strong>lien vers le formulaire sera supprimé</strong>, le formulaire associé mis <strong>hors ligne</strong>.</p>
                    <p>Si vous avez partagé ou mis ce lien sur un portail, <strong>le formulaire ne sera plus accessible pour les demandeurs.</strong></p>`;
    data.buttonTextTrue = 'Confirmer la suppression du lien';
    data.buttonTextFalse = 'Annuler';
    data.buttonColorTrue = 'primary';

    const dialogRef = this.dialog.open(DialogValidationComponent, { data: data });
    dialogRef.updatePosition({top: '50px'});
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.pubSubSvc.publish('loading', true);
        const _form = url.form_obj;
        _form.state = FormState.offline;
        this.subSink.sink = this.urlSvc
          .delete(url)
          .pipe(concatMap(_ => this.formSvc.patch(_form, 'uuid')),
            finalize(() => this.pubSubSvc.publish('loading', false)))
          .subscribe(_ => {
            this.toastySvc.toasty('Lien', 'Le lien a été supprimé et rendu inactif', typeToast.success);
            this.dataTable.reload();
          });
      }
    });
  }

  private _copy_url(row: UrlModel) {
    this.clipboard.copy(this.formSvc.formUrlDemandeurBySlug(row.slug));
  }
}

